import { render, staticRenderFns } from "./ProductProfile.vue?vue&type=template&id=2766b387&scoped=true&"
import script from "./ProductProfile.vue?vue&type=script&lang=js&"
export * from "./ProductProfile.vue?vue&type=script&lang=js&"
import style0 from "./ProductProfile.vue?vue&type=style&index=0&id=2766b387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766b387",
  null
  
)

export default component.exports